import { createFileRoute } from "@tanstack/react-router";
import { AcoesVisualizarPage } from "@/paginas/pg_acoes/acoes-visualizar";

export const Route = createFileRoute("/_authenticated/acoes-visualizar")({
  component: AcoesVisualizarPage,
});
